function Tabs(tabsElement, tabsContentElement, options){
	this.tabsElement = tabsElement;
	this.tabsContentElement = tabsContentElement;
	this.currentTab = false;

	//default options
	this.options = {
		'disableLinks' : false,
		'adjustHeight' : true,
		'history' : false
	};

	//voeg input opties samen met default opties
	for (var attrname in options) { this.options[attrname] = options[attrname]; }

	//binds
	this.onResize = this.onResize.bind(this);
	this.switchTab = this.switchTab.bind(this);

	//verzamel alle knop elementen
	this.tabs = [];
	for(var i=0;i<this.tabsElement.childNodes.length;i++){
		if(this.tabsElement.childNodes[i].nodeType == 1){//alleen toevoegen als het een element is
			this.tabs.push(this.tabsElement.childNodes[i]);
		}
	}

	//verzamel alle content elementen
	this.tabsContent = [];
	for(var i=0;i<this.tabsContentElement.childNodes.length;i++){
		if(this.tabsContentElement.childNodes[i].nodeType == 1){//alleen toevoegen als het een element is
			this.tabsContent.push({
				'element': this.tabsContentElement.childNodes[i],
				'height': this.tabsContentElement.childNodes[i].offsetHeight
			});
		}
	}

	if(this.tabs.length != this.tabsContent.length){
		console.warn('Aantal tabs is niet gelijk aan het aantal knoppen.');
		return false;
	}

	//verwijder no-js classes (dit wordt pas later gedaan omdat anders zonder javascript de content niet meer te benaderen is, dit is hoogstwaarschijnlijk ook beter voor Google)
	this.tabsElement.classList.remove('no-tabs');
	this.tabsContentElement.classList.remove('no-tabs');

	var urlTab = false;

	var tab = false;
	if(window.location.hash.substr(1)){
		tab = this.getTabThroughLocationHash();
	}

	if(this.options.history){
		tab = this.getTabThroughUrl();
	}

	if(tab){
		this.currentTab = tab;
		this.currentTab.classList.add('is-active');

		for(var i=0;i<this.tabsContent.length;i++){
			if(tab === this.tabs[i]){
				this.tabsContent[i]['element'].classList.add('is-active');
			}
		}

		urlTab = true;
	}

	if(!urlTab){
		this.tabs[0].classList.add('is-active');
		this.tabsContent[0]['element'].classList.add('is-active');
		this.currentTab = this.tabs[0];
	}

	for(var i=0;i<this.tabs.length;i++){
		this.tabs[i].addEventListener('click', this.switchTab);
	}

	this.switchTab();

	if(this.options.adjustHeight){
		this.didResize = false;

		window.addEventListener('resize', this.onResize);
	}

	window.addEventListener('hashchange', this.switchTab);

	if(this.options.history){//netter integreren
		window.addEventListener('popstate', function(e){
			this.switchTab(e.state.tab);
		}.bind(this));
	}
}

//could be structured better
Tabs.prototype.switchTab = function(e){
	if(this.options.disableLinks && e && e.target){
		e.preventDefault();
	}

	if(e && e.target){
		var target = e.target;
	}

	if(!target){
		target = this.currentTab;
	}

	if(target.nodeName == 'A'){
		target = target.parentNode;
	}

	if(this.options.history && typeof e == 'string') {
		target = this.getTabThroughUrl(e);
	}

	if(target == window){
		target = this.getTabThroughLocationHash();
		if(!target){ return; }
	}

	for(var i=0;i<this.tabs.length;i++){
		if(target == this.tabs[i]){
			this.currentTab = this.tabs[i];
			this.tabs[i].classList.add('is-active');
			this.tabsContent[i]['element'].classList.add('is-active');
			if(this.options.adjustHeight){
				this.tabsContentElement.setAttribute('style', 'height: ' + this.tabsContent[i]['height'] + 'px;');
			}
			if(this.options.history){//netter integreren
				var count = i + 1;
				if(e && e.target){
					var stateObj = { tab: e.target.getAttribute('href').match(/\/([\w\d-_]+)\/?$/)[1] };
					history.pushState(stateObj, 'page ' + count, e.target.getAttribute('href'));
				}
			}
		}
		else {
			this.tabs[i].classList.remove('is-active');
			this.tabsContent[i]['element'].classList.remove('is-active');
		}
	}
};

Tabs.prototype.getTabThroughLocationHash = function(e){
	var tabUrlHashTester = window.location.hash.substr(1);

	if(tabUrlHashTester){
		for(var i=0;i<this.tabs.length;i++){
			var tabAnchorElement = this.tabs[i].getElementsByTagName('a')[0];

			var regexp = new RegExp('\/?#' + tabUrlHashTester + '$');

			if(tabAnchorElement && regexp.test(tabAnchorElement.getAttribute('href'))){
				return this.tabs[i];
			}
		}
	}

	return false;
};

Tabs.prototype.getTabThroughUrl = function(url){
	var tabUrlTester = window.location.pathname;

	if(tabUrlTester){
		for(var i=0;i<this.tabs.length;i++){
			var tabAnchorElement = this.tabs[i].getElementsByTagName('a')[0];

			var regexp = new RegExp(tabUrlTester + '$');

			if(tabAnchorElement && regexp.test(tabAnchorElement.getAttribute('href'))){
				return this.tabs[i];
			}
		}
	}

	return false;
};

Tabs.prototype.onResize = function(){
	for(var i=0;i<this.tabsContent.length;i++){
		this.tabsContent[i].height = this.tabsContent[i].element.offsetHeight;
	}
	this.switchTab();
};

export default Tabs;